import {
    useMutation,
    useQuery,
    useQueryClient,
    UseQueryResult,
} from '@tanstack/react-query';
import { RQAPICall } from 'store/APIClient';
import { dispatch } from 'store/store';
import {
    GradeMapping,
    PostGradeMappingPayload,
} from 'routes/HumanResourcesModule/Settings/HrGrade/helpers/type';

const GRADE_MAPPING_API_KEY = 'grade_mapping';
const GRADE_MAPPING_ENDPOINT = 'human_resources/hr_grade/grade_mappings';

export const useGetHrGradeMappings = (): UseQueryResult<GradeMapping[]> =>
    useQuery({
        queryKey: [GRADE_MAPPING_API_KEY],
        queryFn: async () => {
            const getResponse = await RQAPICall({
                endpoint: GRADE_MAPPING_ENDPOINT,
            });
            return getResponse.content.data;
        },
        meta: {
            useGlobalOnError: true,
        },
    });

/**
 * Hook to update grade mappings
 */
export const usePutGradeMappingMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (
            payload: PostGradeMappingPayload,
        ): Promise<{
            content: { data: GradeMapping; message: string };
        }> =>
            RQAPICall({
                endpoint: GRADE_MAPPING_ENDPOINT,
                method: 'PUT',
                body: payload,
            }),

        onSuccess: ({ content }) => {
            queryClient.setQueryData(
                [GRADE_MAPPING_API_KEY],
                (oldData: GradeMapping[]) =>
                    oldData.map((item) =>
                        item.id === content.data.id ? content.data : item,
                    ),
            );
            dispatch.vision.notifyUser({
                message: content.message,
                snackType: 'success',
            });
        },
        meta: { useGlobalOnError: true },
    });
};
